import { render, staticRenderFns } from "./AdminGateway.vue?vue&type=template&id=480c5266"
import script from "./AdminGateway.vue?vue&type=script&lang=js"
export * from "./AdminGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports